const routes = [
    {
        path: "/finance/reports",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true
        }
    },
    {
        path: "/student/clubs/payment/report",
        component: () => import("../pages/StudentClubsPaymentReport"),
        meta: {
            isAuthenticated: true,
            permission: 'studentclubstudent_financereport'
        }
    }
];

export default routes;
